/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_SaveInputs */

const en_ledger_query_save = /** @type {(inputs: Ledger_Query_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save source query`)
};

const nl_ledger_query_save = /** @type {(inputs: Ledger_Query_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronquery opslaan`)
};

/**
* | output |
* | --- |
* | "Save source query" |
*
* @param {Ledger_Query_SaveInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_save = /** @type {((inputs?: Ledger_Query_SaveInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_SaveInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_save(inputs)
	return en_ledger_query_save(inputs)
});